module.exports = __webpack_public_path__ + "static/media/statusDraft.a40a1598.svg";